import { useVelavuStream } from "velavu-react";
import {
	AssetUpdate,
	DeviceUpdate,
	objectUpdateFromStreamUpdate,
} from "./object-update";
import {
	VelavuAsset,
	VelavuDevice,
	VelavuStreamUpdateTarget,
} from "velavu-js-api";
import { useCallback, useEffect } from "react";
import { useGlobalEmitter } from "./emitter-context";

/**
 * Subscribes to device updates from all sources
 */
export function useSubscribeCombinedDeviceUpdates(
	callback: (update: DeviceUpdate) => void,
) {
	//Subscribe to remotely streamed device updates
	useVelavuStream(
		VelavuStreamUpdateTarget.Device,
		useCallback(
			(event) => {
				callback(objectUpdateFromStreamUpdate<VelavuDevice>(event));
			},
			[callback],
		),
	);

	//Subscribe to locally emitted device updates
	const emitter = useGlobalEmitter();
	useEffect(() => {
		emitter.on("device", callback);
		return () => {
			emitter.off("device", callback);
		};
	}, [emitter, callback]);
}

/**
 * Subscribes to asset updates from all sources
 */
export function useSubscribeCombinedAssetUpdates(
	callback: (update: AssetUpdate) => void,
) {
	//Subscribe to remotely streamed asset updates
	useVelavuStream(
		VelavuStreamUpdateTarget.Asset,
		useCallback(
			(event) => {
				callback(objectUpdateFromStreamUpdate<VelavuAsset>(event));
			},
			[callback],
		),
	);

	//Subscribe to locally emitted asset updates
	const emitter = useGlobalEmitter();
	useEffect(() => {
		emitter.on("asset", callback);
		return () => {
			emitter.off("asset", callback);
		};
	}, [emitter, callback]);
}
